import AnimatedBeamMultipleOutputDemo from "@/components/animated_beam/AnimatedBeamMultiOutput";
import {
  AnalyticsSvg,
  HierarchySvg,
  MoneySvg,
  SecuritySvg,
} from "@/components/icons/SvgIcons";
import { TerminalComponent } from "@/components/landing/Terminal";
import { CSSProperties, ReactNode } from "react";

interface FeatureContent {
  title: string;
  description: string;
  image_type: "image" | "icon" | "element";
  image?: string | ReactNode;
}

interface FeatureContentType {
  appName: string;
  isDefault: boolean;
  features: FeatureContent[];
}

export function getFeatureContent({
  isDark,
  wallets,
}: {
  isDark: boolean;
  wallets: any;
}): FeatureContentType[] {
  var iconStyle: CSSProperties = {
    fill: "var(--accent-9)",
    width: "100%",
    height: "100%",
  };
  var iconContainerStyle: CSSProperties = {
    backgroundColor: "var(--accent-a2)",
    padding: "20px",
    width: "100%",
    height: "100%",
    margin: "0 auto",
    borderRadius: 200,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return [
    {
      appName: "default",
      isDefault: true,
      features: [
        {
          title: "Crypto Banking Made Simple",
          description:
            "Deposit, transfer, and swap between crypto and fiat effortlessly. Take control of your digital assets with a platform built for the future.",
          image_type: "element",
          image: (
            <AnimatedBeamMultipleOutputDemo
              className="w-full"
              wallets={wallets}
            />
          ),
        },
        {
          title: "Multi-Wallet\nFlexibility",
          description:
            "Manage multiple wallets in one place—crypto, fiat, and stocks—all secured and accessible anytime, anywhere.",
          image_type: "image",
          image: isDark ? "multi-wallet.png" : "multi-wallet-light.png",
        },
        {
          title: "Fast Fiat\nTransactions",
          description:
            "Enjoy hassle-free wire transfers and ACH payments for your traditional banking needs, paired with next-gen efficiency.",
          image_type: "image",
          image: isDark ? "fast-transfer.png" : "fast-transfer-light.png",
        },
        {
          title: "Multi-Asset\nConversions",
          description:
            "Convert fiat to crypto, crypto to stocks, or stocks to fiat in seconds—unmatched flexibility for your financial needs.",
          image_type: "element",
          image: (
            <img
              src={"icons/security.svg"}
              className="object-contain"
              alt={"Fast Fiat Transactions"}
            />
          ),
        },
        {
          title: "Unbreakable Security",
          description:
            "Rest easy with AES-256 encryption, cold storage for crypto, and real-time monitoring—your assets are safe and sound.",
          image_type: "element",
          image: (
            <div className="flex justify-center items-center">
              {/* <TerminalComponent /> */}
            </div>
          ),
        },
      ],
    },
    {
      appName: "banking",
      isDefault: false,
      features: [],
    },
    {
      appName: "investment",
      isDefault: false,
      features: [
        {
          title: "Diverse Investment Options",
          description:
            "From Gold mining, Crypto mining, to Forex trading, NFTs, and stocks, we offer a comprehensive range of investment opportunities to suit your preferences and risk appetite.",
          image_type: "element",
          image: (
            <AnimatedBeamMultipleOutputDemo
              className="w-full"
              wallets={wallets}
            />
          ),
        },
        {
          title: "Expert Guidance",
          description:
            "Benefit from the expertise of seasoned professionals who are dedicated to helping you make informed investment decisions and maximize your returns.",
          image_type: "element",
          image: (
            <div style={iconContainerStyle}>
              <HierarchySvg
                style={iconStyle}
                fill={isDark ? "white" : "black"}
              />
            </div>
          ),
        },
        {
          title: "Transparent Reporting",
          description:
            "Gain insight into your investment performance with transparent and detailed reporting, allowing you to track progress and make adjustments as needed.",
          image_type: "element",
          image: (
            <div style={iconContainerStyle}>
              <AnalyticsSvg
                style={iconStyle}
                fill={isDark ? "white" : "black"}
              />
            </div>
          ),
        },
        {
          title: "Multi-Asset\nConversions",
          description:
            "Convert fiat to crypto, crypto to stocks, or stocks to fiat in seconds—unmatched flexibility for your financial needs.",
          image_type: "element",
          image: (
            <div style={iconContainerStyle}>
              <MoneySvg style={iconStyle} fill={isDark ? "white" : "black"} />
            </div>
          ),
        },
        {
          title: "Unbreakable Security",
          description:
            "Rest easy with AES-256 encryption, cold storage for crypto, and real-time monitoring—your assets are safe and sound.",
          image_type: "element",
          image: (
            <div style={iconContainerStyle}>
              <SecuritySvg
                style={iconStyle}
                fill={isDark ? "white" : "black"}
              />
            </div>
          ),
        },
      ],
    },
  ];
}
